import { coreRoutes } from '../../core/config/routes/routes';
import { appRoutes } from '../../app/config/routes/routes';

export const routes = {
  ...coreRoutes,
  ...appRoutes,
  admin: {
    ...coreRoutes.admin,
    ...appRoutes.admin,
  },
  auth: {
    ...coreRoutes.auth,
    ...appRoutes.auth,
  },
};
